module.exports = __webpack_public_path__ + "img/haarlem_logo_lily.727fed80.svg";